// extracted by mini-css-extract-plugin
module.exports = {"submissionError":"ConsentReminderDialogContainer_submissionError__6WyN9","legalText":"ConsentReminderDialogContainer_legalText__adrUN"};